import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/packing_house_process/${packing_house_process_id}`
    );
  },

  fetchContainer(packing_house_id, packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_templates/container/${packing_house_process_id}/${container_id}`
    );
  },

  downloadQualityInspectsRepXlsx(packing_house_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_inspects/download_quality_inspects_rep_xlsx/${container_id}/${quality_template_id}`,
      { responseType: "blob" }
    );
  },

  fetchQualityInspects(packing_house_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_inspects/${container_id}/${quality_template_id}`
    );
  },

  fetchQualityTemplate(packing_house_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_inspects/quality_template/${container_id}/${quality_template_id}`
    );
  }
};
